import Vue from 'vue'
import axios from 'axios'
import Vuex from 'vuex'
import store from '@/store'
import global_ from './config'//引用模块进来
import router from '@/router'
import qs from 'qs'



//定义公共变量
const get_access_token = () => {
  let access_token = localStorage.getItem("access_token");
  return access_token
};

const get_refresh_token = () => {
  let refresh_token = localStorage.getItem("refresh_token");
  return refresh_token
};

const get_languagen = () => {
  let language = localStorage.getItem("language");
  return language
};

const get_token_type = () => {
  let token_type = localStorage.getItem("token_type");
  return token_type
};

const RETRY = 3;              // 重复请求次数
const RETRY_DELAY = 7000;     // 请求失败后多少毫秒后重新发送请求  写成 0 为立马发送
axios.defaults.timeout = 7000
axios.defaults.baseURL = global_.gloabUrl



function checkVersion(v){
    let version = store.state.home.version
    // console.log(version) //预设置的版本
    // console.log(v) //接口的版本
    if(version < v){
      store.commit('checkVersion_1',1);
    }
}


axios.interceptors.request.use(
  config => {
    store.state.loading.out = true;
    
    //将请求存入vuex
    config.cancelToken = new axios.CancelToken(cancel => {
      store.commit('pushToken', {cancelToken: cancel})
    });



    const access_token = get_access_token();
    const refresh_token = get_refresh_token();
    const token_type = get_token_type();
    const language = get_languagen();      
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    config.headers['Accept-Language'] = language      

    if(access_token && store.state.home.token_status == 0){
        config.headers['Authorization'] =  token_type + ' ' + access_token          
    }else{
        config.headers['Authorization'] =  token_type + ' ' + refresh_token          
      
    }

    
    return config;
  },
  error => {  
    store.state.loading.out = false;    
    return Promise.reject(error);
  });

  axios.interceptors.response.use(
    response => {
      store.state.loading.loading = false;
      store.state.loading.out = false;

    

      return response;
    },
    error => { 
      store.state.loading.out = false;     



      if(axios.isCancel(error)) {
        // console.log('请求取消')
        return
        // return Promise.reject(error);
      }
      
      
      // console.log(error.response.status)
      // console.log(error.message.indexOf('timeout') !== '-1')


      if (error.code === 'ECONNABORTED' || error.message.indexOf('timeout') !== '-1') {
        // console.log('超时');
        //重新请求
        let config = error.config,
          _data = qs.parse(config.data || ''),
          _retryCount = Number(_data.retry_count);
          // console.log(error.config);      
          // console.log(_data);

          // 这里将数据存放到 config.data 里，因为 get方法里 data 是空的，post 不行
          // 判断请求类型，是否继续操作

          if (config.method == 'post'){
            // console.log(config.method)
            store.commit('clearToken'); // 取消请求 
             // UIkit.modal.alert('Time out!');     
            store.dispatch('closeMes',1);       
            store.state.loading.loading = false;
            // return Promise.reject(error);
          }

          
          if (config.method != 'get') {
              return Promise.reject(error);
          }
          // 判断是否超出
          if (_retryCount >= RETRY) {
              if(_retryCount == 3){
                store.dispatch('closeMes',1);       
              }
              return Promise.reject(error);            
          }
          // 设置当前请求次数 进行标记
          _retryCount = _retryCount || 0;
          _data.retry_count = Number(_retryCount) + 1;
          config.data = qs.stringify(_data);

          // 进行定时处理
          let backoff = new Promise((resolve) => {
              setTimeout(() => {
                  resolve();
              }, RETRY_DELAY);
          });
          
          return backoff.then(function() {
              return axios(config);
          });
      }
      // if(!error.response){
      //    console.log('断网了')          
      //    router.push({name: 'error'})
      //  }     

       if (error.response.status === 404) {
            router.push({name: 'error', query: {code: error.response.status}})
            store.commit('clearToken'); // 取消请求  
        }

        if (error.response.status === 401) {
          router.push({name: 'error', query: {code: error.response.status}});
          store.commit('clearToken'); // 取消请求  
        }

        if (error.response.status === 500) {
          router.push({name: 'error', query: {code: error.response.status}});
          store.commit('clearToken'); // 取消请求  
        }    
  });


 



/* 封装get方法*/
export function get(url,params={}){
  return new Promise((resolve,reject)=>{        
        axios.get(url,{
          params:params,
          }).then(response=>{   
            if(!response){
              return
            } 
            checkVersion(response.data.merchant_web_version);            
            resolve(response);
          }).catch(error=>{
            reject(error);          
            })
        });    
}

/* 封装post方法 */



export function post(url,data={}){
  return new Promise((resolve,reject)=>{    
    axios.post(url,data).then(response=>{
        if(response.data.errcode == '-201' || response.data.errcode == '-204' || response.data.errcode== '-203' || response.data.errcode == '-300' ){
              window.localStorage.removeItem('access_token');
              window.localStorage.removeItem('refresh_token');
              window.localStorage.removeItem('token_type');

              router.replace('/login');              
              return
        }
        resolve(response);
      }).catch(error=>{
        reject(error);
    })
  })
}


/* 封装get方法  传cookie*/
export function ajax(url,params={}){
  return new Promise((resolve,reject)=>{
    axios.get(url,{
      params:params,
      withCredentials: true ,
      }).then(response=>{ 
        if(!response){
          return
        }  
        checkVersion(response.data.merchant_web_version);

        // if(response.data.errcode == '-201' || response.data.errcode == '-204' || response.data.errcode == '-203' || response.data.errcode == '-300' ){
        //       window.localStorage.removeItem('access_token');
        //       window.localStorage.removeItem('refresh_token');
        //       window.localStorage.removeItem('token_type');
        //       router.replace('/login');              
        //       return
        // }      
        resolve(response);
      }).catch(error=>{
        reject(error);
        })
    })
}



// WEBPACK FOOTER //
// ./src/components/common/resouces/http.js